import React from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import styled from 'styled-components';
import {getResults, toggleFavorite, performSearch, changeSort} from '../actions/race';
import Loading from './Loading';
import StarIcon from '../icons/star';
import SidebarWidgets from './SidebarWidgets';

class SearchResults extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  ColorThemeHoverA = styled.a`
    color: #6c6b6b !important;

    &:hover {
      color: ${this.props.color} !important;
    }
  `;

  componentDidMount() {
    if(!this.props.searchResults) {
      this.props.performSearch(this.props.search, this.props.match.params && this.props.match.params.division ? this.props.match.params.division : this.props.div);
    }
  }

  toggleFavorite(runner, fav) {
    this.props.toggleFavorite(runner, fav);
  }

  navigateToRunner(runner) {
    this.props.history.push(`/race/${this.props.raceDetail.race_id}/${this.props.eventId}/${runner.$KEY}`);
  }

  changeResultPage(newPage) {
    this.props.performSearch(this.props.search, this.props.div, newPage);
  }

  changeSort(newSortBy) {

    let newSortDir = 'asc';
    if (newSortBy == this.props.sortBy) {
      newSortDir = this.props.sortDir === 'asc' ? 'desc' : 'asc';
    }

    this.props.changeSort(newSortBy, newSortDir);
    this.props.performSearch(this.props.search, this.props.div);
  }

  paddingLeft(str, paddingValue) {
    return String(paddingValue + str).slice(-paddingValue.length);
  }

  renderRPP(i, resultsPage) {

    if (resultsPage - 10 > i) {
      return null;
    } else if (resultsPage + (resultsPage < 10 ? 20 : 10) < i) {
      return null;
    }

    return (<span key={i}>
      {i === resultsPage ? (<span>{i+1}</span>) : (<this.ColorThemeHoverA href="javascript:" onClick={this.changeResultPage.bind(this, i)}>{i+1}</this.ColorThemeHoverA>)}
    </span>);
  }

  render() {

    const {raceDetail, resultsPage, resultsTotal} = this.props;

    if (!raceDetail || !raceDetail.name) return null;
    
    const gridSegmentEventKey = !this.props.eventId || this.props.eventId === '' ? 'NONE' : this.props.eventId;
    const gridSegments = raceDetail.gridSegments[gridSegmentEventKey] || [];

    return (
      <div className="flexbox-container">
        <div className="content">


        <div className="section-leaderboard">
          <div className="section-head">
            <h1 className="section-title" id="section-title">Search Results</h1>

            {/*<div className="section-actions">*/}
              {/*Auto Refresh*/}

              {/*<a href="javascript:;" className="link-on">On</a>*/}

              {/*|*/}

              {/*<a href="javascript:;" className="link-off">Off</a>*/}
            {/*</div>*/}
          </div>

          <div className="section-body">
            <div className="table table-secondary" id="results-container">

              {this.props.searchResults === undefined || this.props.searchResults === null ? (
              <Loading />
              ) : (
                <div>
                  <table id="table-results" width="100%" border="0" cellSpacing="0" cellPadding="0">
                    <thead>
                      {!this.props.raceDetail.columns ?
                        (
                        <tr>
                          <th width="45">Fav</th>
                          <th width="36"><a href="javascript:;" onClick={this.changeSort.bind(this, '_OVERALL')}>Place</a></th>
                          <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_DIV')}>Div</a></th>
                          <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_DIV_PLACE')}>Div Pl</a></th>
                          <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_LAST_NAME')}>Name</a></th>
                          <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_USAT_AGE')}>Age</a></th>
                          <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_CITY')}>City</a></th>
                          <th width="50"><a href="javascript:;" onClick={this.changeSort.bind(this, 'STATE.keyword')}>St</a></th>

                          {
                            gridSegments.map((segment, idx) => (
                              <th key={idx}><a href="javascript:;" onClick={this.changeSort.bind(this, 'TS' + this.paddingLeft(segment.sort_order, '0000'))}>{segment.location}</a></th>
                            ))
                          }

                          <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_FINALTM')}>Time</a></th>

                        </tr>
                        ) : (
                         <tr>
                           <th width="45">Fav</th>
                           <th width="36"><a href="javascript:;" onClick={this.changeSort.bind(this, '_OVERALL')}>Place</a></th>
                           {this.props.raceDetail.columns['Div'] &&
                           <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_DIV')}>Div</a></th>
                           }

                           {this.props.raceDetail.columns['Div Pl'] &&
                           <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_DIV_PLACE')}>Div Pl</a></th>
                           }

                           {this.props.raceDetail.columns['Name'] &&
                           <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_LAST_NAME')}>Name</a></th>
                           }

                           {this.props.raceDetail.columns['Age'] &&
                           <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_USAT_AGE')}>Age</a></th>
                           }

                           {this.props.raceDetail.columns['City'] &&
                           <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_CITY')}>City</a></th>
                           }

                           {this.props.raceDetail.columns['St'] &&
                           <th width="50"><a href="javascript:;" onClick={this.changeSort.bind(this, 'STATE.keyword')}>St</a></th>
                           }

                           {this.props.raceDetail.columns['Country'] &&
                           <th>Country</th>
                           }

                           {this.props.raceDetail.columns['Gender'] &&
                           <th width="50"><a href="javascript:;" onClick={this.changeSort.bind(this, 'SEX.keyword')}>Gender</a></th>
                           }

                           {this.props.raceDetail.columns['Club'] &&
                           <th width="50"><a href="javascript:;" onClick={this.changeSort.bind(this, '_CLUB_NAME')}>Club</a></th>
                           }

                           {this.props.raceDetail.columns['Bib #'] &&
                           <th width="50"><a href="javascript:;" onClick={this.changeSort.bind(this, 'Bib')}>Bib #</a></th>
                           }

                           {
                             gridSegments.map((segment, idx) => (
                               <th key={idx}><a href="javascript:;" onClick={this.changeSort.bind(this, 'TS' + this.paddingLeft(segment.sort_order, '0000'))}>{segment.location}</a></th>
                             ))
                           }

                           <th><a href="javascript:;" onClick={this.changeSort.bind(this, '_FINALTM')}>Time</a></th>
                         </tr>

                        )
                      }


                    </thead>
                    {!this.props.raceDetail.columns ?
                      (
                        <tbody>
                          {!this.props.searchResults || this.props.searchResults.length === 0 &&
                            <tr><td colSpan="100">{this.props.raceDetail.no_results_msg || 'No Results Yet'}</td></tr>
                          }

                        {this.props.searchResults && this.props.searchResults.map((runner, idx) => (
                          <tr className="highlited" key={idx} onClick={this.navigateToRunner.bind(this, runner)}>
                            <td className="aligncenter">
                              <div className="checkbox custom-checkbox">
                                <input type="checkbox" className="fav2" />

                                <label htmlFor="fav1">

                                  {this.props.favorites && this.props.favorites.filter(x => x.$KEY === runner.$KEY).length > 0 ? (
                                    <StarIcon checked style={{height: '22px', width: '22px'}}  onClick={this.toggleFavorite.bind(this, runner, false)} />
                                  ) : (
                                    <StarIcon checked={false} style={{height: '22px', width: '22px'}} onClick={this.toggleFavorite.bind(this, runner, true)} />
                                  )}
                                </label>
                              </div>

                            </td>

                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$OVERALL || '')}} />

                            <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$DIV || '')}} />
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$DIV_PLACE || '')}} />
                            <td className="athleterow">{runner.$TEAM_NAME || `${runner.$FIRST_NAME} ${runner.$LAST_NAME}`}</td>
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$USAT_AGE || '')}} />
                            <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$CITY || '')}} />
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$STATE || '')}} />

                            {
                              gridSegments.map((segment, idx) => (
                                <td key={idx} className="athleterow" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner[segment.current_segment])}} />
                              ))
                            }

                            <td className="athleterow" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$FINALTM || '')}} />


                          </tr>
                        ))}
                        </tbody>
                      ) : (
                        <tbody>
                        {!this.props.searchResults || this.props.searchResults.length === 0 &&
                          <tr><td colSpan="100">{this.props.raceDetail.no_search_msg || 'No Results Found'}</td></tr>
                        }
                        {this.props.searchResults && this.props.searchResults.map((runner, idx) => (
                          <tr className="highlited" key={idx} onClick={this.navigateToRunner.bind(this, runner)}>
                            <td className="aligncenter">
                              <div className="checkbox custom-checkbox">
                                <input type="checkbox" className="fav2" />

                                <label htmlFor="fav1">

                                  {this.props.favorites && this.props.favorites.filter(x => x.$KEY === runner.$KEY).length > 0 ? (
                                    <StarIcon checked style={{height: '22px', width: '22px'}}  onClick={this.toggleFavorite.bind(this, runner, false)} />
                                  ) : (
                                    <StarIcon checked={false} style={{height: '22px', width: '22px'}} onClick={this.toggleFavorite.bind(this, runner, true)} />
                                  )}
                                </label>
                              </div>

                            </td>
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$OVERALL || '')}} />

                            {this.props.raceDetail.columns['Div'] &&
                            <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$DIV || '')}} />
                            }

                            {this.props.raceDetail.columns['Div Pl'] &&
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$DIV_PLACE || '')}} />
                            }

                            {this.props.raceDetail.columns['Name'] &&
                            <td dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$TEAM_NAME || `${runner.$FIRST_NAME} ${runner.$LAST_NAME}`)}} />
                            }

                            {this.props.raceDetail.columns['Age'] &&
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$USAT_AGE)}} />
                            }

                            {this.props.raceDetail.columns['City'] &&
                            <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$CITY || '')}} />
                            }

                            {this.props.raceDetail.columns['St'] &&
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$STATE || '')}} />
                            }

                            {this.props.raceDetail.columns['Country'] &&
                            <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$COUNTRY || '')}} />
                            }

                            {this.props.raceDetail.columns['Gender'] &&
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$SEX || '')}} />
                            }

                            {this.props.raceDetail.columns['Club'] &&
                            <td className="" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$CLUB_NAME || '')}} />
                            }

                            {this.props.raceDetail.columns['Bib #'] &&
                            <td className="aligncenter" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$KEY || '')}} />
                            }

                            {
                              gridSegments.map((segment, idx) => (
                                <td key={idx} className="athleterow" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner[segment.current_segment])}} />
                              ))
                            }

                            <td className="athleterow" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(runner.$FINALTM || '')}} />

                          </tr>
                        ))}

                        </tbody>
                      )

                    }

                  </table>
                  <div className="resultsPerPage">
                    {
                      resultsPage !== 0 && (
                        <span><this.ColorThemeHoverA href="javascript:" onClick={this.changeResultPage.bind(this, resultsPage - 1)}>&lt;&lt;</this.ColorThemeHoverA></span>
                      )
                    }
                    {[...Array(Math.min(Math.ceil(resultsTotal/30), 1000))].map((x, i) => this.renderRPP(i, resultsPage))}
                    {
                      resultsTotal !== 0 && this.props.resultsPage !== Math.ceil(resultsTotal/30)-1 && (
                        <span><this.ColorThemeHoverA href="javascript:" onClick={this.changeResultPage.bind(this, resultsPage + 1)}>&gt;&gt;</this.ColorThemeHoverA></span>
                      )
                    }
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <SidebarWidgets />
    </div>
  );
  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    favorites: state.rr360.favorites,
    searchResults: state.rr360.searchResults,
    resultsTotal: state.rr360.searchResultsTotal,
    resultsPage: state.rr360.searchResultsPage,
    eventId: state.rr360.eventId,
    color: state.rr360.theme.primaryColor,
    sortBy: state.rr360.sortBy,
    sortDir: state.rr360.sortDir
  };
}


export default connect(mapStateToProps, {getResults, toggleFavorite, performSearch, changeSort})(SearchResults);



// WEBPACK FOOTER //
// ./src/components/SearchResults.js